import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const createUser = createAsyncThunk(
  "user/register",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await axios.post("/user/register",
        userData, {
        headers: {
          "Content-Type": "application/json",
          token: userData.token
        },
      }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
);

export const updateUserDetails = createAsyncThunk(
  "user/updateUserProfile",
  async ({ formData, token }, { rejectWithValue }) => {
    try {
      const response = await axios.put("/user/updateUserProfile",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            token
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
);

export const loginUser = createAsyncThunk(
  "user/login",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await axios.post("/user/login",
        userData,
        {
          headers: {
            'Content-Type': 'application/json',
            token: userData.token
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
);

export const changePassword = createAsyncThunk(
  "user/changePassword",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/user/changePassword",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
);

export const sendResetPasswordLink = createAsyncThunk(
  "auth/sendResetPasswordLink",
  async ({ email, frontendUrl, pageName }, { rejectWithValue }) => {
    try {
      const response = await axios.post("/user/sendResetPasswordLink",
        { email, frontendUrl, pageName },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
);

export const resetPassword = createAsyncThunk(
  "user/resetPassword",
  async ({ id, password, confirmPassword }, { rejectWithValue }) => {
    try {
      const response = await axios.post("/user/resetpassword/", {
        id, password, confirmPassword,
      }, {
        headers: {
          "Content-Type": "application/json",
        }
      }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
);

export const getUserInfo = createAsyncThunk(
  "user/getUserInfo",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await axios.post("/user/getUserInfo",
        userData, {
        headers: {
          'Content-Type': 'application/json',
          token: userData.token
        }
      }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
);

export const logOutUser = createAsyncThunk(
  "user/logOutUser",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await axios.post("/user/logOutUser",
        userData, {
        headers: {
          'Content-Type': 'application/json',
          token: userData.token
        }
      }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
);

export const checkAuthorization = createAsyncThunk(
  "user/checkAuthorization",
  async (_, thunkAPI) => {
    try {

      const userType = Number(sessionStorage.getItem("userType"));

      const response = await axios.post(
        "/user/checkAuthorization",
        { 
          userType,
          token:
            thunkAPI?.getState()?.auth?.userInfo?.token ||
            thunkAPI?.getState()?.auth?.token ||
            null
        },
        {
          headers: {
            "Content-Type": "application/json",
            token:
              thunkAPI?.getState()?.auth?.userInfo?.token ||
              thunkAPI?.getState()?.auth?.token ||
              null
          }
        }
      );

      return response.data;

    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);
const userSlice = createSlice({
  name: "user",
  initialState: {
    userInfo: [],
    loading: false,
    error: null,
    loginSuccessMessage: null,
    loginErrorMessage: null,
    registrationSuccessMessage: null,
    registrationErrorMessage: null,
    updateErrorMessage: false,
    updateSuccessMessage: false,
    passwordChangeSuccessMessage: null,
    passwordChangeErrorMessage: null,
    passwordResetLinkSuccessMessage: null,
    passwordResetLinkErrorMessage: null,
    passwordResetSuccessMessage: null,
    passwordResetErrorMessage: null,
    isAuthenticated: false,
    logOutUserSuccessMessage: null,
    logOutUserErrorMessage: null,
    token: null,
    checkExistUserData: null,
  },
  reducers: {
    resetLoginMessage: (state) => {
      state.loginSuccessMessage = null;
      state.loginErrorMessage = null;
    },
    resetRegistrationMessage: (state) => {
      state.registrationSuccessMessage = null;
      state.registrationErrorMessage = null;
    },
    resetPasswordChangeMessage: (state) => {
      state.passwordChangeSuccessMessage = null;
      state.passwordChangeErrorMessage = null;
    },
    resetPasswordResetLinkMessage: (state) => {
      state.passwordResetLinkSuccessMessage = null;
      state.passwordResetLinkErrorMessage = null;
    },
    resetPasswordResetMessage: (state) => {
      state.passwordResetSuccessMessage = null;
      state.passwordResetErrorMessage = null;
    },
    resetUpdateMessage: (state) => {
      state.updateErrorMessage = null;
      state.updateSuccessMessage = null;
    },
    resetLogOutUserMessage: (state) => {
      state.logOutUserSuccessMessage = null;
      state.logOutUserErrorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createUser.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        if (action.payload.success === false) {
          state.registrationErrorMessage = action.payload.result.message;
        } else {
          state.registrationSuccessMessage = action.payload.result.message;
        }
      })
      .addCase(createUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateUserDetails.pending, (state) => {
        state.loading = true;
        state.updateSuccessMessage = null;
        state.updateErrorMessage = null;
      })
      .addCase(updateUserDetails.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.updateErrorMessage = action.payload.result.message;
        } else {
          state.updateSuccessMessage = action.payload.result.message;
        }
      })
      .addCase(updateUserDetails.rejected, (state, action) => {
        state.loading = false;
        state.updateErrorMessage = action.payload.result.message;
      })
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.isAuthenticated = false;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        if (action.payload.success === false) {
          state.loginErrorMessage = action.payload.result.message;
          state.isAuthenticated = false;
          state.token = null;
        } else {
          state.loginSuccessMessage = action.payload.result.message;
          state.isAuthenticated = true;
          state.token = action.payload.result.list.token;
          state.userInfo = action.payload.result.list || action.payload.result.list._doc;
        }
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.isAuthenticated = false;
        state.token = null;
      })
      .addCase(logOutUser.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.isAuthenticated = false;
      })
      .addCase(logOutUser.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        if (action.payload.success === false) {
          state.logOutUserErrorMessage = action.payload.result.message;
        } else {
          state.logOutUserSuccessMessage = action.payload.result.message;
          state.token = null;
        }
        state.isAuthenticated = false;
      })
      .addCase(logOutUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.isAuthenticated = false;
      })
      .addCase(changePassword.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(changePassword.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        if (action.payload.success === false) {
          state.passwordChangeErrorMessage = action.payload.result.message;
        } else {
          state.passwordChangeSuccessMessage = action.payload.result.message;
        }
      })
      .addCase(changePassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(sendResetPasswordLink.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(sendResetPasswordLink.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success) {
          state.passwordResetLinkSuccessMessage = action.payload.result.message;
        } else {
          state.passwordResetLinkErrorMessage = action.payload.result.message;
        }
      })
      .addCase(sendResetPasswordLink.rejected, (state, action) => {
        state.loading = false;
        state.passwordResetLinkErrorMessage = action.payload.message;
      })
      .addCase(resetPassword.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(resetPassword.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        if (action.payload.success === false) {
          state.passwordResetErrorMessage = action.payload.result.message;
        } else {
          state.passwordResetSuccessMessage = action.payload.result.message;
        }
      })
      .addCase(resetPassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getUserInfo.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getUserInfo.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === true) {
          state.userInfo = action.payload.result.list;
        } else {
          state.errorMessage = action.payload.result.message;
          state.userInfo = null;
          state.searchMessage = action.payload.result.message;

        }
      })
      .addCase(getUserInfo.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(checkAuthorization.pending, (state) => {
        state.loading = true;
      })
      .addCase(checkAuthorization.fulfilled, (state, action) => {
        state.loading = false
        if (action.payload.success === false) {
          state.isAuthenticated = false;
          state.token = null;
        } else {
          state.isAuthenticated = true;
          state.token = action?.payload?.result?.list?.token;
        }
      })
      .addCase(checkAuthorization.rejected, (state, action) => {
        state.loading = false;
        state.isAuthenticated = false;
        state.token = null;
      });
  },
});

export const {
  resetLoginMessage,
  resetRegistrationMessage,
  resetLogOutUserMessage,
  resetPasswordChangeMessage,
  resetPasswordResetMessage,
  resetPasswordResetLinkMessage,
  resetUpdateMessage
} = userSlice.actions;

export default userSlice.reducer;